module.exports = __webpack_public_path__ + "assets/img/91bd721af03feb539d55c93673bf108f.png";